import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2720f15e&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/bluehost-site-migrator/bluehost-site-migrator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2720f15e')) {
      api.createRecord('2720f15e', component.options)
    } else {
      api.reload('2720f15e', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=2720f15e&", function () {
      api.rerender('2720f15e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "source/components/App.vue"
export default component.exports